import { Grid, Container, Typography } from '@mui/material';
import { Icon } from '@iconify/react';

export default function Services() {
  const services = [
    {
      title: 'Área de Cliente',
      text: 'Únete a la comunidad de los que quieren Ser Más y disfruta de ventajas exclusivas.',
      link: 'https://www.repsol.es/particulares/',
      linkText: 'Ir al Área de Cliente'
    },
    {
      title: 'Vivit',
      text: 'Si eres cliente de Luz y Gas, utiliza nuestra app para gestionar tu energía.',
      link: 'https://www.repsol.es/particulares/digital/repsol-vivit/',
      linkText: 'Acceder a Vivit'
    },
    {
      title: 'Waylet',
      text: 'Waylet, ahorra en combustible y paga sin bajarte del coche',
      link: 'https://www.repsol.es/particulares/digital/waylet/',
      linkText: 'Acceder a Waylet'
    },
    {
      title: 'Pide tu bombona online',
      text: 'Haz tu pedido de bombonas cuándo y dónde quieras.',
      link: 'https://www.repsol.es/particulares/digital/pide-tu-bombona/',
      linkText: 'Pide tu bombona'
    }
  ];

  return (
    <Container>
      <Grid container>
        <Grid item xs={12}>
          <Typography style={styles.titleSection}>Tus servicios</Typography>
        </Grid>
      </Grid>
      <Grid container>
        {services.map((service, index) => {
          return (
            <Grid key={index} item xs={12} sm={6} md={4}>
              <div style={styles.servicesCard}>
                <Icon icon="bi:bag-fill" style={styles.servicesIcon} />
                <div style={styles.serviceMiniSection}>
                  <Typography style={styles.serviceTitle}>{service.title}</Typography>
                  <Typography style={styles.serviceText}>{service.text}</Typography>
                  {service.link &&
                    service.link !== '' &&
                    service.linkText &&
                    service.linkText !== '' && (
                      <a href={service.link} style={styles.serviceLink}>
                        {service.linkText}
                        <Icon icon="fa:angle-right" style={styles.iconArrow} />
                      </a>
                    )}
                </div>
              </div>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
}

const styles = {
  iconArrow: { verticalAlign: 'sub', marginLeft: 10, fontSize: 20 },
  titleSection: {
    color: '#ff6000',
    fontSize: 30,
    marginTop: 40,
    marginBottom: 30,
    fontFamily: "'Exo 2', sans-serif"
  },
  servicesCard: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: '20px 10px',
    marginRight: 20,
    marginBottom: 20
  },
  servicesIcon: {
    color: '#ff6000',
    float: 'left' as 'left'
  },
  serviceMiniSection: {
    marginLeft: '30px'
  },
  serviceTitle: {
    color: '#4e4e4e',
    fontWeight: 700,
    marginBottom: 5
  },
  serviceText: {
    color: '#a9a9a9'
  },
  serviceLink: {
    color: '#2a8487',
    textDecoration: 'none',
    fontWeight: 700,
    marginTop: 5,
    display: 'block'
  }
};
